var _excluded = ["onChange", "defaultValue", "placeholder", "isDisabled", "autoFocus"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { Input as ChakraInput } from '@chakra-ui/react';
import { createRef, useEffect, useImperativeHandle, useState } from 'react';
import { Container, Group } from '../../../containers';
import { forwardRef, useBoolean, useUpdateEffect } from '../../../utils';
import { useMultiStyleConfig } from '../../../utils/use-style-config';
import { IconButton } from '../../action';
import { InputGroup } from '../../internal/InputGroup';
/**
 * @deprecated Please use SearchBarProps instead.
 */

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/**
 * @deprecated Please use SearchBar instead.
 */
export var DeprecatedSearchBar = forwardRef((_ref, forwardRef) => {
  var {
    onChange,
    defaultValue = '',
    placeholder,
    isDisabled = false,
    autoFocus
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var [isClearClicked, clearClicked] = useBoolean(false);
  var [value, setValue] = useState(defaultValue);
  var [isInputFocus, setInputFocus] = useState(false);
  var [isHover, setIsHover] = useState(false);
  var [isTyping, setIsTyping] = useState(false);
  var style = useMultiStyleConfig('DeprecatedSearch', {
    value,
    isTyping,
    isHover
  });
  var inputRef = /*#__PURE__*/createRef();
  useImperativeHandle(forwardRef, () => inputRef.current);

  var resetQuery = () => {
    clearClicked.on();
    setValue('');
    setInputFocus(true);

    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  var updateQuery = _ref2 => {
    var {
      target: {
        value
      }
    } = _ref2;
    setValue(value);
  };

  useUpdateEffect(() => {
    onChange(value, {
      clear: isClearClicked
    });
    clearClicked.off();
  }, [value]);
  useEffect(() => {
    var userTyping = setTimeout(() => {
      if (isTyping) {
        setIsTyping(false);
      }
    }, 500);
    return () => {
      clearTimeout(userTyping);
    };
  }, [isTyping]);
  return /*#__PURE__*/_jsx(InputGroup, _objectSpread(_objectSpread({
    "data-component": "DeprecatedSearchBar",
    __css: style['container'],
    "aria-disabled": isDisabled || undefined,
    "data-focus": !isDisabled && isInputFocus || undefined,
    onMouseEnter: () => setIsHover(true),
    onMouseLeave: () => setIsHover(false)
  }, props), {}, {
    children: /*#__PURE__*/_jsxs(Group, {
      alignItems: "center",
      spacing: "xs",
      width: "full",
      children: [/*#__PURE__*/_jsx(ChakraInput, {
        "aria-label": "search input",
        "data-testid": "search-input",
        placeholder: placeholder,
        value: value,
        isDisabled: isDisabled,
        onChange: updateQuery,
        onInput: () => setIsTyping(true),
        onFocus: () => setInputFocus(true),
        onBlur: () => setInputFocus(false),
        "data-focus": !isDisabled && isInputFocus || undefined,
        sx: style['field'],
        autoFocus: autoFocus,
        ref: inputRef
      }), value && /*#__PURE__*/_jsx(Container, {
        paddingX: "xs",
        paddingY: "xs",
        width: "fit-content",
        children: /*#__PURE__*/_jsx(IconButton, {
          icon: "close-mini",
          "aria-label": "close",
          variant: "naked",
          size: "large",
          "data-testid": "search-clear-button",
          onClick: resetQuery
        })
      })]
    })
  }));
});
DeprecatedSearchBar.displayName = 'DeprecatedSearchBar';
//# sourceMappingURL=DeprecatedSearchBar.js.map